"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 36 36" },
  React.createElement("path", { d: "M24.514 2a.5.5 0 0 0-.353.854l3.181 3.174-6.988 6.988a.5.5 0 0 0 0 .707l1.923 1.923a.5.5 0 0 0 .707 0l6.991-6.991 3.172 3.166a.5.5 0 0 0 .853-.354V2zM11.486 34a.5.5 0 0 0 .353-.854l-3.181-3.174 6.988-6.988a.5.5 0 0 0 0-.707l-1.923-1.923a.5.5 0 0 0-.707 0l-6.991 6.99-3.171-3.165a.5.5 0 0 0-.854.354V34z" })
);

